// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"353":"contact","462":"legal","594":"about"}[chunkId] + "." + {"353":"ef1cafe1","462":"50ef31e6","594":"d86a20af"}[chunkId] + ".css";
};